<template>
	<div class="flex flex-col gap-8">

		<FormGroup :label="$t('forms.user.user_roles_form.role')" :error-text="form.errors?.role_id">
			<Dropdown
					v-model="form.role_id"
					:options="rolesStore.getRoleOptions"
					option-label="display_name"
					option-value="id"
					@change="form.validate('role_id')"
			/>
		</FormGroup>

		<FormGroup :label="$t('forms.user.user_roles_form.team')" :error-text="form.errors?.team_id">
			<Dropdown
					v-model="form.team_id"
					:options="teamsStore.getTeamOptions"
					option-label="display_name"
					option-value="id"
					@change="form.validate('team_id')"
			/>
		</FormGroup>

	</div>

	<template v-if="hasOnSaveListener">
		<div class="flex justify-end mt-8">
			<Button @click="$emit('on-save', form)" :label="$t('forms.common.save')" :disabled="form.processing"/>
		</div>
	</template>
</template>

<script>
import { mapStores } from "pinia";
import { useRolesStore } from "@/stores/roles.js";
import { useTeamsStore } from "@/stores/teams.js";
import FormGroup from "@/Components/FormGroup.vue";

export default {
	name: "UserPropertiesForm",
	components: {FormGroup},
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapStores(useRolesStore),
		...mapStores(useTeamsStore),
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
	},
	async mounted() {
		await this.rolesStore.indexRoleOptions();
		await this.teamsStore.indexTeamOptions();
	}
}
</script>

<style scoped>

</style>